var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('SuccessMessage',{attrs:{"type":"success","title":_vm.$t('modules.examExceptions.create.stepper.confirmation.component.title'),"subtitle":_vm.$t('modules.examExceptions.create.stepper.confirmation.component.subtitle'),"actionPrimary":_vm.actionPrimary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }